<template lang="html">
  <section
    class="custom-display-element-draggable"
    draggable
    @dragstart="startDrag"
    @dragend="endDrag"
  >
    <div class="widget">
      <div class="d-row" v-if="!isRequestingTranslations">
        <span class="w-name">{{ widgetName }}</span>
        <select-option
          class="select-option"
          :id="`cde-version-dropdown-${widget.uuid}`"
          :default-version-object="latestPublishedVersion"
          :options="sortedVersions"
          @on-select-option-change="onSelectOptionChange"
        />
      </div>
      <div v-else class="loader"></div>
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME } from "@/static/global-variables";
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import selectOption from "@/components/SelectOption";

  export default  {
    name: "custom-display-element-draggable",
    components: {
      selectOption
    },
    props: {
      widget: {
        type: Object,
        default: function() {
          return {};
        }
      },
      dropEffect: {
        type: String,
        default: "move"
      }
    },
    data() {
      return {
        selectedVersionUuid: ""
      }
    },
    computed: {
      userLocale() {
        const user = this.$store.getters.user;
        return user ? user.language : "en_US";
      },
      widgetName() {
        return distributionChannelUtil.findTranslatedLabel(this.translations, this.userLocale) || this.widget.name;
      },
      sortedVersions() {
        return distributionChannelUtil.formatAndSortSemanticVersion(this.widget.versions);
      },

      latestPublishedVersion() {
        const publishedVersions = this.sortedVersions.filter(v => {
          return !v.version.includes("-");
        });
        return publishedVersions[0] || this.sortedVersions[0];
      },
      translations() {
        return this.allWidgetTranslations[this.widget.widgetId] || [];
      },
      allWidgetTranslations() {
        return this.$store.getters[MUTATION_NAME.ALL_WIDGET_TRANSLATIONS] || {};
      },
      isRequestingTranslations() {
        return this.$store.getters[MUTATION_NAME.WIDGET_TRANSLATION_REQUEST][this.widget.widgetId];
      }
    },
    mounted () {
      if(!this.translations.length && !this.isRequestingTranslations) {
        this.setRequestFlag(true);
        DistributionChannelsService.getWidgetTranslations(this.widget.widgetId)
        .finally(() => {
          this.setRequestFlag(false);
        });
      }
    },
    methods: {
      setRequestFlag(isRequest) {
        this.$store.commit(MUTATION_NAME.WIDGET_TRANSLATION_REQUEST, {
          uuid: this.widget.widgetId,
          request: isRequest
        });
      },
      startDrag(ev) {
        this.emitEvent("on-drag-start-element", ev);
      },
      endDrag(ev) {
        this.emitEvent("on-drag-end-element", ev);
      },
      emitEvent(eventName, ev) {
        const uuid = this.selectedVersionUuid || this.latestPublishedVersion.uuid;
        const versionObject = this.widget.versions.find(v => {
          return v.uuid === uuid;
        })
        const obj = {
          ev: ev,
          data: {
            modal: "AddEditCustomDisplayElementModal",
            dropEffect: this.dropEffect,
            props: {
              widget: this.widget,
              version: versionObject ? versionObject.version : null
            }
          }
        };
        this.$emit(eventName, obj);
      },
      onSelectOptionChange(versionUuid) {
        this.selectedVersionUuid = versionUuid;
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-display-element-draggable {
    position: relative;
    .widget {
      box-sizing: border-box;
      padding: 0.5rem 0 0.5rem 0;
      cursor: move;
      min-height: 2.2rem;
      .d-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow-wrap: break-word;
        .w-name {
          width: 65%;
          padding-left: 0.5rem;
        }
        .select-option {
          margin-right: 0.5rem;
          width: 30%;
        }
      }
      .loader {
        width: 0.9rem;
        height: 0.9rem;
        margin: 0;
      }
    }
    .widget:hover {
      background: var(--SELECTED_LIST_ITEM, rgba(21, 137, 238, 0.1));
      box-shadow: inset 0.125rem 0 0 var(--SELECTED_ITEM_BORDER, #1b96ff);
    }
  }
</style>
